jQuery(function($)
{
    var
        { hide } = orion,
        classDeleted = 'mark-deleted',
        model = {},
        view = {};

    (function()
    {
        var
            $body = $('body'),
            $container = $('#shoppinglist-container'),
            { show } = orion,
            apiShoppingList = orion.api.shoppinglist,
            apiCart = orion.api.cart.orderitems,
            $cart = $('#basket-onsite'),
            ghostAnimationRunning = false;

        view.$list = $('.list-items', $container);

        $('.list-items .item', $container).each(function()
        {
            var
                $li = $(this),
                productNumber = $li.attr('id');

            model[productNumber] = {
                'deleted': false,
                'productNumber': productNumber
            };

            view[productNumber] = {
                '$item': $li,
                '$deleted': $li.next('.' + classDeleted)
            };
        });

        function handleAddToBasket(e)
        {
            e.preventDefault();

            var
                $addTo = $(this),
                productNumber = $addTo.data('product-number'),
                quantity = $('input[name=quantity]', $container).val(),
                $selectorProductImage = $('li[id=' + productNumber + '] img', $container);

            animateImageToCart($($selectorProductImage), $cart, productNumber);

            $body.addClass(orion.constants.ClassProcessing);
            $body.removeClass(orion.constants.ClassBasketUpdated);

            apiCart.create({
                'productNumber': productNumber,
                'quantity': quantity
            }).done(function()
            {
                $container.trigger(orion.constants.EventCartProductCreated, {
                    'productNumber': productNumber
                });
            })
                .always(function()
                {
                    $body.removeClass(orion.constants.ClassProcessing);
                });
        }

        function deleteItem(productNumber)
        {
            var
                thisView = view[productNumber],
                thisModel = model[productNumber],
                data = {
                    'productNumber': productNumber
                };

            return apiShoppingList.del(data)
                .done(function()
                {
                    $container.trigger(orion.constants.EventShoppingListProductDeleted, data);
                    hide(thisView.$item);
                    show(thisView.$deleted);
                    thisModel.deleted = true;
                })
                .fail(function()
                {
                    hide(thisView.$deleted);
                    show(thisView.$item);
                    thisModel.deleted = false;
                });
        }

        function undoDeleteItem(productNumber)
        {
            var
                thisView = view[productNumber],
                thisModel = model[productNumber],
                data = {
                    'productNumber': productNumber
                };

            return apiShoppingList.create(data)
                .done(function()
                {
                    $container.trigger(orion.constants.EventShoppingListProductCreated, data);
                    hide(thisView.$deleted);
                    show(thisView.$item);
                    thisModel.deleted = false;
                });
        }

        function handleDeleteClick(e)
        {
            var
                $delete = $(this),
                productNumber = $delete.data('product-number');

            e.preventDefault();

            hide($delete);

            deleteItem(productNumber)
                .always(function()
                {
                    show($delete);
                });
        }

        function handleUndoDeleteClick(e)
        {
            var
                $undo = $(this),
                productNumber = $undo.data('product-number');

            e.preventDefault();

            hide($undo);

            undoDeleteItem(productNumber)
                .always(function()
                {
                    show($undo);
                });
        }

        function animateImageToCart($img, $cart, $productNumber)
        {
            if (ghostAnimationRunning)
            {
                return;
            }

            if (!window.requestAnimationFrame)
            {
                return;
            }

            ghostAnimationRunning = true;

            var
                offsetImage = $img.offset(),
                offsetCart = $cart.offset(),
                $ghostImage = $img.clone().insertAfter($('li[id= ' + $productNumber + '] .container'))
                    .css({
                        'position': 'absolute',
                        'top': '0px',
                        'z-index': 96
                    }),
                offsetGhostImage = $ghostImage.offset();

            $ghostImage.css(orion.toTranslateStyle(offsetImage.left - offsetGhostImage.left,
                offsetImage.top - offsetGhostImage.top));
            requestAnimationFrame(function()
            {
                var style = orion.toTranslateStyle(offsetCart.left - offsetGhostImage.left,
                    offsetCart.top - offsetGhostImage.top);

                style.transform += ' scale(0.01)';

                $ghostImage.css($.extend(style, {
                    'opacity': 0,
                    'transform-origin': 'top left',
                    'transition': 'all 0.5s ease-in'
                }));

                setTimeout(function()
                {
                    $ghostImage.remove();
                    ghostAnimationRunning = false;
                }, 500);
            });
        }

        hide($('.' + classDeleted));

        $container
            .on('click', '.addToBasket', handleAddToBasket)
            .on('click', '.list-items .delete', handleDeleteClick)
            .on('click', '.list-items .undo-delete', handleUndoDeleteClick);
    })();
});
